import { ADMIN_CLASS_USE_MOCK } from "../config/admin.config";
import { classApiHttp } from "./classApi.http";
import { classApiMock } from "./classApi.mock";

export const classApi = ADMIN_CLASS_USE_MOCK ? classApiMock : classApiHttp;
